import { Observable, of, zip } from "rxjs";
import { map } from "rxjs/operators";
import { INavToken } from "./../interfaces/INavToken";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";

let _navTokensProp: Record<string, INavToken> = {};

export function setNavTokenProps(navTokensProp: Record<string, INavToken>) {
  _navTokensProp = navTokensProp;
}

function propTokensToObservable(propTokens: INavToken[]) {
  const navTokens: Record<string, string> = {};
  for (let i = 0; i < propTokens.length; i++) {
    const response = propTokens[i];
    navTokens[response.tokenName] = response.url;
  }

  return of(navTokens);
}

function requestNavTokens(neededTokens: string[]) {
  return HttpClient.get<any[]>({
    baseUri:
      ApiEndpointResolver.getNavigationTokensUrl() +
      neededTokens.map((token) => `requestedIds=${token}`).join("&"),
  }).pipe(
    map((response) => {
      const navTokens: Record<string, string> = {};

      for (let i = 0; i < response.length; i++) {
        navTokens[response[i].tokenName] = response[i].url;
      }

      return navTokens;
    })
  );
}

const NavigationTokensService = {
  get(tokens: string[]): Observable<Record<string, string>> {
    return ApiCacheService.withCache_Array(
      "NavigationTokensService",
      tokens,
      (neededTokens) => {
        const propTokens: INavToken[] = [];
        const requestTokens: string[] = [];
        for (let i = 0; i < neededTokens.length; i++) {
          const token = neededTokens[i];
          if (_navTokensProp[token]) {
            propTokens.push(_navTokensProp[token]);
          } else {
            requestTokens.push(token);
          }
        }

        if (requestTokens.length === 0 && propTokens.length !== 0) {
          return propTokensToObservable(propTokens);
        }

        if (requestTokens.length !== 0 && propTokens.length !== 0) {
          return zip(
            propTokensToObservable(propTokens),
            requestNavTokens(requestTokens)
          ).pipe(
            map((x) => {
              const lhs = x[0];
              const rhs = x[1];

              for (const key in rhs) {
                lhs[key] = rhs[key];
              }

              return lhs;
            })
          );
        }
        return requestNavTokens(requestTokens);
      }
    );
  },
};

export default NavigationTokensService;
